import type { Monaco } from '@monaco-editor/react'
import type { CodeAppConfigType } from '../../../types'

export const setTsOptions = (monaco: Monaco, types: CodeAppConfigType[]) => {
  const typescript = monaco.languages.typescript
  typescript.typescriptDefaults.setCompilerOptions({
    // noLib: true,
    module: typescript.ModuleKind.ESNext,
    moduleResolution: typescript.ModuleResolutionKind.NodeJs,
    lib: ['ESNext', 'ES2015'],
    target: typescript.ScriptTarget.ESNext,
    allowNonTsExtensions: true,
    allowSyntheticDefaultImports: true,
    esModuleInterop: true,
    types: ['node'],
    typeRoots: ['node_modules/@types'],
  })

  typescript.typescriptDefaults.setDiagnosticsOptions({
    diagnosticCodesToIgnore: [
      1375, // top level await
      7044, // no implicit any
      2488, // Type 'number[]' must have a '[Symbol.iterator]()' method that returns an iterator
      1108, // A 'return' statement can only be used within a function body.
    ],
  })

  for (const t of types) {
    monaco.languages.typescript.typescriptDefaults.addExtraLib(t.definition, `${t.path}.d.ts`)
  }
}

export const setPythonOptions = (monaco: Monaco, types: CodeAppConfigType[]) => {}

export const getUUID = () => {
  let d = new Date().getTime() //Timestamp
  let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0 //Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0
      d = Math.floor(d / 16)
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0
      d2 = Math.floor(d2 / 16)
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}
